import { render, staticRenderFns } from "./PromoteAccount.vue?vue&type=template&id=642841b9&"
import script from "./PromoteAccount.vue?vue&type=script&lang=js&"
export * from "./PromoteAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports